import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "api/axios.config";
import { constructApiQuery } from "api/index";

const CLIENTS_BASE = "/clients";

const getClients = (page, limit, orderby, filterParameters, search) => {
  let url = `${CLIENTS_BASE}?`;
  if (page) url += `&page=${page}`;
  if (limit) url += `&limit=${limit}`;
  if (orderby) url += `&orderby=${orderby}`;

  const parameters = constructApiQuery(
    filterParameters?.branch || null,
    filterParameters?.teamId || null,
    filterParameters?.feeEarnerRef || null,
  );
  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  if (search) url += `&search=${search}`;

  return API.get(url);
};

const buildOrderBy = (sort) => {
  if (!sort) return "clientRef";
  return sort.dir === "desc" ? `${sort.field} desc` : sort.field;
};

const fetchClientsList = createAsyncThunk(
  "clients/fetchList",
  async ({ page, limit, sort, filterParameters, searchValue }) => {
    if (page === undefined) return undefined;
    const res = await getClients(
      page,
      limit,
      buildOrderBy(sort),
      filterParameters,
      searchValue,
    );
    return res.data;
  },
);

const initialState = {
  clientsList: undefined,
  isLoading: false,
  clientEditPermission: false,
};

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    toggleClientEditPermission: (state) => {
      state.clientEditPermission = !state.clientEditPermission;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchClientsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsList = action.payload;
      })
      .addCase(fetchClientsList.rejected, (state) => {
        state.isLoading = false;
        state.clientsList = { data: [], total: 0 };
      });
  },
});

const { toggleClientEditPermission } = clientsSlice.actions;

const clientsReducer = clientsSlice.reducer;

export { clientsReducer, fetchClientsList, toggleClientEditPermission };
